import { render, staticRenderFns } from "./BalancesPlanFloatBtns.vue?vue&type=template&id=22b62384&"
import script from "./BalancesPlanFloatBtns.vue?vue&type=script&lang=js&"
export * from "./BalancesPlanFloatBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports